import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { Trip } from '../trip.service';
import { AuthService } from '../auth.service';

@Injectable({
    providedIn: 'root'
})
export class MockTripService {
    private authService = inject(AuthService);

    private tripsSubject = new BehaviorSubject<Trip[]>([]);
    trips$ = this.tripsSubject.asObservable();

    private readonly STORAGE_KEY = 'mock_trips';

    constructor() {
        // Load initial data from localStorage
        const stored = localStorage.getItem(this.STORAGE_KEY);
        if (stored) {
            this.tripsSubject.next(JSON.parse(stored));
        }

        this.authService.user$.subscribe(user => {
            if (!user) {
                this.tripsSubject.next([]);
            }
        });
    }

    private saveToStorage(trips: Trip[]) {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(trips));
        this.tripsSubject.next(trips);
    }

    async fetchTrips() {
        return Promise.resolve();
    }

    async addTrip(trip: Omit<Trip, 'id' | 'createdAt' | 'createdBy' | 'status'>) {
        const current = this.tripsSubject.value;
        const newTrip: Trip = {
            id: 'mock-trip-' + Date.now(),
            ...trip,
            createdBy: 'test-user-id',
            status: 'active',
            members: ['test-user-id'],
            createdAt: new Date()
        };
        this.saveToStorage([newTrip, ...current]);
        return Promise.resolve();
    }

    getTripSnapshot(id: string): Trip | undefined {
        return this.tripsSubject.value.find(t => t.id === id);
    }

    async deleteTrip(id: string) {
        const current = this.tripsSubject.value;
        const updated = current.filter(t => t.id !== id);
        this.saveToStorage(updated);
        return Promise.resolve();
    }

    async addMemberByEmail(tripId: string, email: string) {
        return Promise.resolve();
    }

    async removeMember(tripId: string, uidToRemove: string) {
        return Promise.resolve();
    }
}
